import styled from 'styled-components';

export const NonProfitDonationsSection = styled.div`
    .table-section{
        padding-bottom: 0px;
        border-radius: 20px;
        margin-bottom: 30px;
        box-shadow: 0px 5px 30px #0000001A;
    }
    th{
        max-width: 100px;
        white-space: normal;
        padding: 17px 10px !important;
        font-size:16px;
        line-height: 24px;

        @media screen and (max-width: 991px){
            white-space: nowrap;
            max-width: 350px;
        }
    }

    td{
        max-width: 185px;
        padding: 20px 10px !important;
        overflow: hidden;
           white-space: normal;
        @media screen and (max-width: 991px){
            white-space: nowrap;
            max-width: 350px;
        }
    }
`; 

export const Title = styled.h1`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size:40px;
    font-weight: bold;
    line-height: 58px;
    margin-bottom: 30px;  
    @media screen and (max-width:1199px) {
        font-size: 35px;
        line-height: 40px;
    }
    @media screen and (max-width:991px) {
        font-size: 30px;
        line-height: 35px;
    }
    @media screen and (max-width:575px) {
        font-size: 28px;
        line-height: 40px;
        margin-bottom: 20px;
    }
`;

export const DonationsReceived = styled.div`
    display: flex;
    justify-content: end;
    gap: 15px;
    align-items: center;
    margin-bottom:20px;

    @media screen and (max-width:575px) {
      flex-wrap: wrap;
        width: 100%;
        justify-content: start;
    }
`;
export const ReceivedText = styled.h3`
    color: #000000;
    font-family: "Jost", sans-serif;
    font-size:20px;
    font-weight: bold;
    line-height: 29px;
    margin-bottom: 0px;
`;

export const DownloadReportBtn = styled.div`
    .report-btn{
        background: #01606F 0% 0% no-repeat padding-box;
        box-shadow: 0px 5px 20px #0000001A;
        border-radius: 10px;
        opacity: 1;
        border: none;
        padding: 13px 20px;
        color: #fff;
        font-family: "Jost", sans-serif;
        font-size:16px;
        font-weight:500;
        line-height: 23px;
     &:active{
       background: #01606F 0% 0% no-repeat padding-box;
      }   
      &:focus-visible{
     box-shadow:none;
      } 
    }
`;

export const NonProfitDonationsText = styled.div`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 500;
    line-height: 27px;
    margin-bottom: 20px;

    @media screen and (max-width: 767px){
        font-size:18px;
        line-height: 24px;
    }

    a{
        color: #01606F;
        font-weight: bold;
        text-decoration: none;
    }  
`;